export const _NOTIFICATION = {
    FETCH_NOTIFICATION_REQUEST : 'FETCH_NOTIFICATION_REQUEST',
    FETCH_NOTIFICATION_SUCCESS : 'FETCH_NOTIFICATION_SUCCESS',
    FETCH_NOTIFICATION_ERROR : 'FETCH_NOTIFICATION_ERROR'
}